export const updateRooms = (hotels, hotel, rooms) => {
    const hotelIndex = hotels.findIndex(
        ({supplierCode, cityCode, hotelCode}) =>
            hotel.supplierCode === supplierCode && hotel.cityCode === cityCode && hotel.hotelCode === hotelCode
    )
    hotels[hotelIndex].rooms = rooms
    hotels[hotelIndex].updatedRooms = true
}

export const updateWishlist = (hotels, hotel, isWishlist) => {
    const hotelIndex = hotels.findIndex(
        ({supplierCode, cityCode, hotelCode}) =>
            hotel.supplierCode === supplierCode && hotel.cityCode === cityCode && hotel.hotelCode === hotelCode
    )
    hotels[hotelIndex].wishlist = isWishlist
}

export const updateHotelWishlist = (hotels, hotel, isWishlist) => {
    const hotelIndex = hotels.findIndex(
        ({supplierCode, cityCode, hotelCode}) =>
            hotel.supplierCode === supplierCode && hotel.cityCode === cityCode && hotel.hotelCode === hotelCode
    )

    if (hotelIndex >= 0) {
        if (!isWishlist) {
            hotels.splice(hotelIndex, 1)
        } else hotels[hotelIndex].wishlist = isWishlist
    } else if (isWishlist) {
        hotel.wishlist = isWishlist
        hotels.push(hotel)
    }
}

export const mapHotels = hotels =>
    hotels.map(({location, ...hotel}) => ({
        ...hotel,
        ...location,
        parentName: location.countryName,
        type: 'hotel',
    }))
